import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Nav, Tab } from "react-bootstrap";
import "./tabCompStyle.scss";

const TabComp = forwardRef(({ tabs = [], onTabChange }, ref) => {
  const [activeTab, setActiveTab] = useState(0);

  useImperativeHandle(ref, () => ({
    setActiveTab: (index) => setActiveTab(index),
  }));
  
  if (!tabs.length) {
    return <p>No tabs available</p>;
  }

  return (
    <Tab.Container
      activeKey={activeTab}
      onSelect={(k) => {
        const index = parseInt(k);
        setActiveTab(index);
        if (onTabChange) onTabChange(index);
      }}>
      <Nav variant="tabs" className="mb-3">
        {tabs.map((tab, index) => (
          <Nav.Item key={index}>
            <Nav.Link eventKey={index}>{tab.title}</Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      <Tab.Content>
        {tabs.map((tab, index) => (
          <Tab.Pane key={index} eventKey={index}>
            {tab.content}
          </Tab.Pane>
        ))}
      </Tab.Content>
    </Tab.Container>
  );
});

export default TabComp;
